import AddCircleOutlineRoundedIcon from "@mui/icons-material/AddCircleOutlineRounded";
import Button from "@mui/material/Button";
import generateTestId from "utils/generateTestId";

const AddNewNote = ({ append, pane }: { append: any; pane?: string }) => {
    return (
        <Button
            onClick={() => {
                append();
            }}
            className="common-fullwidth-button"
            disabled={localStorage.getItem("disable_form") === "true"}
            style={{ marginTop: "1rem", width: "50%", justifySelf: "end" }}
            data-testid={generateTestId(`add-another-bank-account-${pane}`, "button")}
        >
            <AddCircleOutlineRoundedIcon fontSize="small" className="AddEquipmentIcon" />
            <span>Add Note</span>
        </Button>
    );
};

export default AddNewNote;
